import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Grid, Typography } from '@mui/material'
import requestImg from 'assets/images/requestImg.png'

function RequestRide() {
  const navigate = useNavigate();
  const onClickRide = () =>{
    sessionStorage.clear()
    navigate('/home');
   
  }
  return (
    <Grid container
    xs={12}
    className='p10'
    >
        <Grid item
         justifyContent='space-between'
         direction='column'
         className='marginTop25 width100'
        md={12}
        >
         <img src={requestImg} alt='request' className='width100'/> 
        </Grid>
        <Grid item
        md={12}
        >
            <Typography className='font20 fontMedium'>Get a ride in minutes</Typography>
            <Typography className='rideText'>Book an Iter from a web browser, no app install necessary.</Typography>
            <Button className='btnRequest'
            onClick={onClickRide}
                >Request ride</Button>
        </Grid>

    </Grid>
  )
}

export default RequestRide
